/**
 * @constructor
 */
function ProductContract() {
    /**
     * @type {string}
     */
    this.id = '';

    /**
     * @type {string}
     */
    this.description = '';

    /**
     * @type {Array}
     */
    this.categories = [];

    /**
     * @type {string}
     */
    this.name = '';

    /**
     * @type {number}
     */
    this.necessaryDesigns = 0;

    /**
     * @type {number}
     */
    this.price = 0;

    /**
     * @type {number}
     */
    this.minPiece = 1;

    /**
     * @type {Array<ProductImageContract>}
     */
    this.images = [];

    /**
     * @type {Array<ProductImageContract>}
     */
    this.designs = [];

    /**
     * @type {Array<ProductParamContract>}
     */
    this.params = [];

    /**
     * @type {boolean}
     */
    this.disabled = true;
}

export default ProductContract;
